import { switchMap, filter, map, tap, withLatestFrom } from 'rxjs/operators'
import { authSelectors } from 'src/app/core/auth/auth.selectors'
import { AppState } from 'src/app/core/core.state'
import { normalizeToSchema } from 'src/app/shared/normalization/normalization'
import { normalizationActions } from 'src/app/shared/normalization/normalization.actions'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { Payment } from './payment'
import { paymentActions } from './payment.actions'
import * as fromPayments from './payment.reducer'
import { PaymentService } from './payment.service'

@Injectable()
export class PaymentEffects extends ResourceEffects<Payment> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public paymentService: PaymentService
  ) {
    super(fromPayments.FEATURE_NAME, paymentService, paymentActions, actions$)
  }

  fetchMyPayments = createEffect(() =>
    this.actions$.pipe(
      ofType(paymentActions.fetchMyPayments),
      withLatestFrom(this.store.select(authSelectors.selectMember)),
      filter(([action, member]) => Boolean(member)),
      switchMap(([action, member]) =>
        this.paymentService.getManyByMemberId(member.id, action.params).pipe(
          map((payments) =>
            normalizationActions.upsertMany({
              entities: normalizeToSchema({ payments })
            })
          )
        )
      )
    )
  )
}
